import {GeneralAction} from '../../../@types/actions';
import {GET_ACTIVE_EVENTS} from '../../../constants/MonitorConstants';

export const GetActiveEventsAction = (): GeneralAction<undefined> => ({
    type: GET_ACTIVE_EVENTS,
    payload: undefined,
});
